import React, { useEffect, useState } from "react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import { apiRoutes } from "../../../../routes/api/apiRoutes";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import PageHeading from "../../../../components/admin/common/PageHeading";
import { Link } from "react-router-dom";

const AdminMentor = () => {
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  const [requests, setRequests] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedMentor, setSelectedMentor] = useState(null);

  useEffect(() => {
    callAPI("get", "admin/get-mentor-list", "");
  }, []);

  useEffect(() => {
    if (Array.isArray(responce?.data) && statusCode === 200 && requests.length === 0) {
      // Add default active value if not provided
      const updatedData = responce.data.map((mentor) => ({
        ...mentor,
        active: mentor.active ?? false,
      }));
      setRequests(updatedData);
    }
  }, [responce, statusCode]);

  const handleStatusUpdate = (id, status) => {
    callAPI("post", apiRoutes.admin.mentorRequestApproved, {
      id: id,
      status: status,
    });
    const updated = requests.map((req) =>
      req.id === id ? { ...req, status: status } : req
    );
    setRequests(updated);
  };

  const handleAssignStudent = (mentor) => {
    alert(`Assign Student clicked for ${mentor.first_name} ${mentor.last_name}`);
    // You can open a modal or navigate to another page here
    setSelectedMentor(mentor);
    setShowModal(true);
  };

  const handleToggleStatus = (mentor) => {
    const newStatus = !mentor.active;
    const updated = requests.map((req) =>
      req.id === mentor.id ? { ...req, active: newStatus } : req
    );
    setRequests(updated);
    console.log(`Set ${mentor.first_name} active: ${newStatus}`);
    // Optional: callAPI to persist active status
  };

  return (
    <AdminAppBody
      content={
        <div className="container">
          <PageHeading
            title="Mentor List"
            subTitle="Manage all registered users with their roles and statuses."
          />
          {/* <Link to="/add/mentor">
            <button className="btn btn-primary mb-3">Add Mentor</button>
          </Link> */}

          <div className="sys-list-table card shadow-sm rounded-lg mt-4 overflow-hidden">
            <div className="table-responsive">
              <table className="table table-hover align-middle sys-list-table__content">
                <thead className="table-light">
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Mobile No</th>
                    <th>Experience</th>
                    <th>Skills</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {requests.map((mentor) => (
                    <tr key={mentor.id}>
                      <td>{mentor.first_name + " " + mentor.last_name}</td>
                      <td>{mentor.email}</td>
                      <td>{mentor.mobile_no}</td>
                      <td>{mentor.experiance}</td>
                      <td>{mentor.skills}</td>
                      <td>
                        {mentor.status === 0
                          ? "Pending"
                          : mentor.status === 1
                          ? "Accepted"
                          : "Rejected"}
                      </td>
                      <td>
                        {mentor.status === 0 && (
                          <>
                            <button
                              className="btn btn-success btn-sm me-2"
                              onClick={() => handleStatusUpdate(mentor.id, 1)}
                            >
                              Accept
                            </button>
                            <button
                              className="btn btn-danger btn-sm me-2"
                              onClick={() => handleStatusUpdate(mentor.id, 2)}
                            >
                              Reject
                            </button>
                          </>
                        )}
                       <Link to={`/mentor/assign/${mentor.id}`}>
  <button className="btn btn-primary btn-sm me-2">Assign</button>
</Link>

                        <button
                          className={`btn btn-sm ${
                            mentor.active
                              ? "btn-outline-success"
                              : "btn-outline-secondary"
                          }`}
                          onClick={() => handleToggleStatus(mentor)}
                        >
                          {mentor.active ? "Active" : "Inactive"}
                        </button>
                      </td>
                    </tr>
                  ))}
                  {requests.length === 0 && !loading && (
                    <tr>
                      <td colSpan="7" className="text-center">
                        No mentors found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default AdminMentor;
